var map = {
	"./404.vue": [
		"+H76",
		4
	],
	"./column-content/ApplyCooperation.vue": [
		"jqLz",
		3
	],
	"./column-content/Article.vue": [
		"YoFT",
		0,
		12
	],
	"./column-content/ArticleList.vue": [
		"4Qij",
		0,
		7
	],
	"./column-content/ContactUs.vue": [
		"wdry",
		6
	],
	"./column-content/DonationLog.vue": [
		"MpxO",
		0,
		8
	],
	"./column-content/Integral.vue": [
		"cPZP",
		0,
		11
	],
	"./column-content/MainPage.vue": [
		"+yVz",
		1,
		0
	],
	"./column-content/News.vue": [
		"j/EA",
		0,
		13
	],
	"./column-content/NewsList.vue": [
		"U+6m",
		2,
		0
	],
	"./column-content/Person.vue": [
		"EXxa",
		0,
		9
	],
	"./column-content/PersonList.vue": [
		"oQtQ",
		0,
		5
	],
	"./column-content/Search.vue": [
		"NN93",
		10
	],
	"./developing.vue": [
		"UixA",
		14
	],
	"./index.vue": [
		"8hXn"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Opzk";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/views lazy ^\.\/.*\.vue$
// module id = Opzk
// module chunks = 16